/* Fashion CITY — 상품 페이지 커스텀 옵션
   손님이 스타일·색상·사이즈별 수량·문구·글씨체·실 색·아트웍 파일·자리·크기를 고르면
   1) 옆의 상품 사진이 그 제품으로 바뀌고 그 위에 미리보기가 뜨고
      (뒷면 자리를 고르면 뒷면 사진으로 바뀝니다)
   2) 장바구니 / 주문서에 그대로 따라갑니다 (line item properties).
   3) 손님이 화면에서 본 그 목업을 JPG 로 떠서 주문에 함께 붙입니다  ← Mockup
   4) 손님이 고른 설정을 되살리는 주소도 함께 붙입니다              ← Design link

   ★ 모자 스타일·색상 사진 : assets/fc-po-colors.js
   ★ 스웻셔츠 색상 사진   : assets/fc-po-sweatshirt.js
   ★ 기본 작업 위치·실 색·사이즈 목록 : assets/fc-po-places.js

   ── 사이즈별 수량 ──
   옷(apparel)에서는 S/M/L/XL 칸이 뜨고, 그 합계가 자동으로 주문 수량이 됩니다.
   모자·가방은 사이즈가 하나라서 칸이 안 뜨고 예전처럼 수량만 고릅니다.

   ── 프루프(시안) 선택 ──
   1) 디자이너 시안 받고 컨펌 후 제작  (컨펌 후 7~10 영업일)
   2) 시안 없이 화면 그대로 제작        (3~5 영업일)
   → 주문서에 Proof 로 찍힙니다.

   ── 연락처 ──
   휴대폰(문자 가능) 필수, 이메일 선택. 주문서에 Mobile / Email 로 찍힙니다.
   개인정보라서 Design link 주소에는 절대 넣지 않습니다.

   ── 파일 첨부 ──
   쇼피파이의 AJAX 장바구니는 파일을 올리지 못합니다.
   그래서 목업을 붙이는 순간부터는 form.submit() 으로 일반 전송을 합니다.
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('fc-po-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var FONTS = [
    { n: 'Classic Serif', c: 'fcpo-f1' },
    { n: 'Clean Sans',    c: 'fcpo-f2' },
    { n: 'Bold Block',    c: 'fcpo-f3' },
    { n: 'Script',        c: 'fcpo-f4' },
    { n: 'Collegiate',    c: 'fcpo-f5' },
    { n: 'Typewriter',    c: 'fcpo-f6' }
  ];
  var REC = 'Recommend one for me';

  var PROOFS = [
    { k: 'proof',
      n: 'Send me a proof first',
      s: 'Our designer draws it up and emails you a proof. Nothing gets made until you say yes.',
      lead: 'About 7–10 business days after you approve',
      pv: 'Designer proof first — production starts after customer approves (about 7–10 business days after approval)' },
    { k: 'asis',
      n: 'No proof needed — make it as shown',
      s: 'Go straight into production exactly the way it looks on this page.',
      lead: 'About 3–5 business days',
      pv: 'No proof — make as shown on site (about 3–5 business days)' }
  ];
  function proofOf(k) {
    for (var i = 0; i < PROOFS.length; i++) if (PROOFS[i].k === k) return PROOFS[i];
    return PROOFS[0];
  }

  var PLACE = {
    cap: [
      { v: 'Front panel', x: 50, y: 47, w: 34, sizes: [2, 3, 4] },
      { v: 'Left side',   x: 27, y: 52, w: 14, sizes: [1.5, 2, 2.5] },
      { v: 'Right side',  x: 73, y: 52, w: 14, sizes: [1.5, 2, 2.5] },
      { v: 'Back',        x: 50, y: 52, w: 18, sizes: [1.5, 2, 2.5] }
    ],
    apparel: [
      { v: 'Left chest',  x: 38, y: 36, w: 15, sizes: [3, 4, 5] },
      { v: 'Full front',  x: 50, y: 40, w: 40, sizes: [8, 10, 12] },
      { v: 'Full back',   x: 50, y: 42, w: 40, sizes: [10, 12, 14] },
      { v: 'Sleeve',      x: 19, y: 45, w: 11, sizes: [1.5, 2, 3] }
    ],
    bag: [
      { v: 'Front', x: 50, y: 50, w: 44, sizes: [5, 8, 10] },
      { v: 'Back',  x: 50, y: 50, w: 44, sizes: [5, 8, 10] }
    ]
  };
  var SIZE_WORDS = ['Small', 'Medium', 'Large'];

  var EMB = window.FCPO_EMB || [
    ['Black', 'rgb(17,17,17)'], ['White', 'rgb(255,255,255)'], ['Red', 'rgb(200,16,46)'],
    ['Royal', 'rgb(27,63,174)'], ['Gold', 'rgb(200,164,48)'], ['Beige', 'rgb(217,199,167)']
  ];
  var PUFF = window.FCPO_PUFF || [
    ['Baby Pink', 'rgb(246,198,208)'], ['Beige', 'rgb(220,201,168)'], ['Brown', 'rgb(107,74,47)'],
    ['Blue', 'rgb(43,93,191)'], ['Dark Green', 'rgb(18,73,43)']
  ];
  var HUES = [
    ['Red', 0, 100, 100, 0], ['Orange', 0, 60, 100, 0], ['Yellow', 0, 15, 100, 0],
    ['Lime', 40, 0, 100, 0], ['Green', 85, 10, 100, 10], ['Teal', 85, 20, 40, 0],
    ['Cyan', 100, 0, 0, 0], ['Blue', 100, 70, 0, 0], ['Violet', 75, 90, 0, 0],
    ['Magenta', 0, 100, 0, 0], ['Pink', 0, 70, 20, 0], ['Brown', 35, 60, 80, 25]
  ];
  var TINTS = [1, 0.72, 0.46, 0.22];
  var NEUTRALS = [[0,0,0,100],[0,0,0,75],[0,0,0,50],[0,0,0,25],[0,0,0,10],[0,0,0,0]];

  function rgbOf(c, m, y, k) {
    var f = function (v) { return Math.round(255 * (1 - v / 100) * (1 - k / 100)); };
    return 'rgb(' + f(c) + ',' + f(m) + ',' + f(y) + ')';
  }
  function cmykLabel(c, m, y, k) {
    return 'C' + Math.round(c) + ' M' + Math.round(m) + ' Y' + Math.round(y) + ' K' + Math.round(k);
  }
  var CMYK = (function () {
    var out = [], t, h, n;
    for (t = 0; t < TINTS.length; t++) {
      for (h = 0; h < HUES.length; h++) {
        var H = HUES[h], s = TINTS[t];
        var c = H[1] * s, m = H[2] * s, y = H[3] * s, k = H[4] * s;
        out.push([cmykLabel(c, m, y, k), rgbOf(c, m, y, k)]);
      }
    }
    for (n = 0; n < NEUTRALS.length; n++) {
      var N = NEUTRALS[n];
      out.push([cmykLabel(N[0], N[1], N[2], N[3]), rgbOf(N[0], N[1], N[2], N[3])]);
    }
    return out;
  })();

  var STY = (window.FCPO_STYLES && window.FCPO_STYLES[CFG.handle]) || null;
  var PROP_STYLE = (STY && STY.propStyle) || 'Cap style';
  var PROP_COLOR = (STY && STY.propColor) || 'Cap color';

  // 옷 사이즈 목록 (없으면 사이즈 칸을 안 만듭니다)
  var SIZERUN = (window.FCPO_SIZERUN_BY_HANDLE && window.FCPO_SIZERUN_BY_HANDLE[CFG.handle])
             || (window.FCPO_SIZERUN && window.FCPO_SIZERUN[CFG.category])
             || null;

  var basePlaces = (window.FCPO_PLACE_BY_HANDLE && window.FCPO_PLACE_BY_HANDLE[CFG.handle])
            || (window.FCPO_PLACE && window.FCPO_PLACE[CFG.category])
            || PLACE[CFG.category] || PLACE.apparel;
  var places = basePlaces;

  function curStyle() { return STY ? STY.styles[state.styleIdx] : null; }
  function applyStylePlaces() {
    var st = curStyle();
    places = (st && st.place) ? [st.place] : basePlaces;
    if (state.place >= places.length) state.place = 0;
  }

  var state = {
    mode: 'text',
    text: '',
    font: REC,
    place: 0,
    size: 1,
    run: {},
    styleIdx: 0,
    styleName: '',
    styleSku: '',
    capColor: '',
    capImg: '',
    capImgBack: '',
    color: '',
    colorCss: '',
    method: '',
    fileUrl: '',
    fileName: '',
    proof: 'proof',
    phone: '',
    email: ''
  };

  function digits(v) { return String(v || '').replace(/[^0-9]+/g, ''); }

  function viewImg() {
    var p = places[state.place];
    if (p && p.view === 'back' && state.capImgBack) return state.capImgBack;
    return state.capImg;
  }

  var root = null, overlay = null, overlayTag = null, mediaBox = null, lastVariant = '';
  var sending = false;

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function sizeLabel(p, i) {
    var inches = p.sizes[i];
    var pretty = (inches % 1 === 0) ? inches : inches.toFixed(1);
    return SIZE_WORDS[i] + ' · about ' + pretty + '"';
  }
  function fontClass(name) {
    for (var i = 0; i < FONTS.length; i++) if (FONTS[i].n === name) return FONTS[i].c;
    return 'fcpo-f2';
  }
  function lum(css) {
    var m = String(css).match(/([0-9]+)[^0-9]+([0-9]+)[^0-9]+([0-9]+)/);
    if (!m) return 0;
    return (0.299 * (+m[1]) + 0.587 * (+m[2]) + 0.114 * (+m[3])) / 255;
  }

  // ── 사이즈별 수량 ──
  function runTotal() {
    if (!SIZERUN) return 0;
    var t = 0;
    for (var i = 0; i < SIZERUN.length; i++) t += (parseInt(state.run[SIZERUN[i]], 10) || 0);
    return t;
  }
  function runLabel() {
    if (!SIZERUN) return '';
    var out = [];
    for (var i = 0; i < SIZERUN.length; i++) {
      var n = parseInt(state.run[SIZERUN[i]], 10) || 0;
      if (n > 0) out.push(SIZERUN[i] + ' ' + n);
    }
    return out.join(' · ');
  }
  function runCode() {
    if (!SIZERUN) return '';
    var out = [];
    for (var i = 0; i < SIZERUN.length; i++) {
      var n = parseInt(state.run[SIZERUN[i]], 10) || 0;
      if (n > 0) out.push(SIZERUN[i] + ':' + n);
    }
    return out.join(';');
  }
  function runFromCode(s) {
    if (!SIZERUN || !s) return;
    var parts = String(s).split(';');
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split(':');
      if (kv.length === 2) {
        var n = parseInt(kv[1], 10);
        if (!isNaN(n) && n > 0) state.run[kv[0]] = n;
      }
    }
  }
  function qtyInput() {
    var f = getForm();
    return f ? f.querySelector('[name="quantity"]') : null;
  }
  function minQty() {
    var q = qtyInput();
    var m = q ? parseInt(q.getAttribute('min'), 10) : 0;
    return m > 0 ? m : 1;
  }
  function syncQty() {
    if (!SIZERUN) return;
    var q = qtyInput();
    if (!q) return;
    var w = q.closest ? q.closest('.quantity-wrapper') : null;
    if (w) w.classList.add('fcpo-qty-locked');
    q.setAttribute('readonly', 'readonly');
    var t = runTotal();
    if (t > 0 && String(q.value) !== String(t)) {
      q.value = t;
      q.dispatchEvent(new Event('input', { bubbles: true }));
      q.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function updateRunUI() {
    if (!root || !SIZERUN) return;
    var tot = root.querySelector('[data-fcpo-runtotal]');
    if (tot) {
      var t = runTotal(), mn = minQty();
      tot.textContent = t + (t === 1 ? ' piece' : ' pieces') + (t < mn ? ' — need ' + mn + '+' : '');
    }
  }
  function renderRun() {
    if (!root || !SIZERUN) return;
    var wrap = root.querySelector('[data-fcpo-run]');
    if (!wrap) return;
    var h = '';
    for (var i = 0; i < SIZERUN.length; i++) {
      var s = SIZERUN[i];
      var n = parseInt(state.run[s], 10) || 0;
      var id = 'fcpo-run-' + String(s).replace(/[^a-zA-Z0-9]+/g, '');
      h += '<label class="fcpo__runcell' + (n > 0 ? ' is-set' : '') + '" for="' + id + '">' +
        '<span>' + esc(s) + '</span>' +
        '<input type="number" id="' + id + '" min="0" step="1" inputmode="numeric" ' +
        'data-fcpo-run-size="' + esc(s) + '" value="' + (n > 0 ? n : '') + '" placeholder="0">' +
        '</label>';
    }
    wrap.innerHTML = h;
    updateRunUI();
  }

  function showErr(msg) {
    if (!root) return;
    var e = root.querySelector('.fcpo__err');
    if (e && msg) e.textContent = msg;
    root.classList.add('is-invalid');
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // ── 디자인 링크 ──
  // 개인정보(휴대폰·이메일)는 절대 여기 넣지 않습니다.
  var LINK_KEYS = ['fcs', 'fcc', 'fcm', 'fct', 'fcf', 'fcl', 'fcp', 'fcz', 'fcr', 'fcv'];
  function designLink() {
    var vals = [state.styleIdx, state.capColor, state.mode, state.text,
                state.font, state.color, state.place, state.size, runCode(), state.proof];
    var out = [];
    for (var i = 0; i < LINK_KEYS.length; i++) {
      out.push(LINK_KEYS[i] + '=' + encodeURIComponent(String(vals[i])));
    }
    return location.protocol + '//' + location.host + location.pathname + '?' + out.join('&');
  }
  function param(k) {
    var m = String(location.search).match(new RegExp('[?&]' + k + '=([^&]*)'));
    if (!m) return null;
    try { return decodeURIComponent(m[1].replace(/[+]/g, '%20')); } catch (e) { return m[1]; }
  }
  function applyLink() {
    if (param('fcc') === null && param('fct') === null && param('fcs') === null) return;
    var n = function (k, d) { var v = parseInt(param(k), 10); return isNaN(v) ? d : v; };
    state.styleIdx = n('fcs', 0);
    state.capColor = param('fcc') || '';
    state.mode = param('fcm') === 'logo' ? 'logo' : 'text';
    state.text = param('fct') || '';
    state.font = param('fcf') || REC;
    state.color = param('fcl') || '';
    state.place = n('fcp', 0);
    state.size = n('fcz', 1);
    state.proof = param('fcv') === 'asis' ? 'asis' : 'proof';
    runFromCode(param('fcr'));
    if (STY && (state.styleIdx < 0 || state.styleIdx >= STY.styles.length)) state.styleIdx = 0;
  }

  function variantTitle() {
    var f = getForm();
    var i = f && f.querySelector('[name="id"]');
    var id = i ? String(i.value) : '';
    var list = CFG.variants || [];
    for (var k = 0; k < list.length; k++) if (String(list[k].id) === id) return list[k].title || '';
    return list.length ? (list[0].title || '') : '';
  }
  function methodOf(title) {
    var t = String(title).toLowerCase();
    if (t.indexOf('puff') > -1) return 'puff';
    if (t.indexOf('print') > -1 || t.indexOf('color') > -1) return 'print';
    if (t.indexOf('patch') > -1) return 'patch';
    return 'emb';
  }
  function paletteFor(m) {
    if (m === 'puff') return { list: PUFF, chart: false, label: 'Puff color',
      hint: '3D Puff — five puff colors.' };
    if (m === 'print') return { list: CMYK, chart: true, label: 'Print color',
      hint: 'Full-color print — pick the closest chip. Sending your own CMYK or Pantone numbers? Put them in the notes when you email us the artwork.' };
    if (m === 'patch') return { list: EMB, chart: false, label: 'Patch color',
      hint: 'Patch — pick the main thread color.' };
    return { list: EMB, chart: false, label: 'Thread color',
      hint: 'Embroidery — pick your thread color.' };
  }

  function chip(name, value, label, sub, checked) {
    var id = name + '-' + String(value).replace(/[^a-zA-Z0-9]+/g, '');
    return '<span class="fcpo__opt fcpo__opt--chip">' +
      '<input type="radio" name="' + name + '" id="' + id + '" value="' + esc(value) + '"' +
      (checked ? ' checked' : '') + '>' +
      '<label for="' + id + '">' + esc(label) +
      (sub ? '<small>' + esc(sub) + '</small>' : '') + '</label></span>';
  }
  function swatch(value, css, showName, checked) {
    var id = 'fcpo-color-' + String(value).replace(/[^a-zA-Z0-9]+/g, '');
    return '<span class="fcpo__opt fcpo__opt--sw">' +
      '<input type="radio" name="fcpo-color" id="' + id + '" value="' + esc(value) + '" data-css="' + esc(css) + '"' +
      (checked ? ' checked' : '') + '>' +
      '<label for="' + id + '" title="' + esc(value) + '">' +
      '<span class="fcpo__chipc" style="background:' + esc(css) + '"></span>' +
      (showName ? '<span class="fcpo__cname">' + esc(value) + '</span>' : '') +
      '</label></span>';
  }
  function fontCard(name, cls, checked, glyph) {
    var id = 'fcpo-font-' + name.replace(/[^a-zA-Z0-9]+/g, '');
    return '<span class="fcpo__opt">' +
      '<input type="radio" name="fcpo-font" id="' + id + '" value="' + esc(name) + '"' +
      (checked ? ' checked' : '') + '>' +
      '<label for="' + id + '">' +
      '<span class="fcpo__sample ' + cls + '" data-fcpo-sample>' + (glyph || 'Your Text') + '</span>' +
      '<span class="fcpo__fname">' + esc(name) + '</span>' +
      '</label></span>';
  }
  function proofCard(p, checked) {
    var id = 'fcpo-proof-' + p.k;
    return '<input type="radio" name="fcpo-proof" id="' + id + '" value="' + esc(p.k) + '"' +
      (checked ? ' checked' : '') + '>' +
      '<label for="' + id + '">' +
      '<strong>' + esc(p.n) + '</strong>' +
      '<small>' + esc(p.s) + '</small>' +
      '<span class="fcpo__lead">' + esc(p.lead) + '</span>' +
      '</label>';
  }

  function buildFieldset() {
    var box = el('div', 'fcpo');
    box.setAttribute('data-fcpo', '');
    box.appendChild(el('p', 'fcpo__hd', 'Make it yours'));

    if (STY) {
      if (STY.styles.length > 1) {
        var fsty = el('div', 'fcpo__field');
        fsty.appendChild(el('span', 'fcpo__label', esc(STY.styleLabel || 'Style')));
        var swrap = el('div', 'fcpo__opts');
        swrap.setAttribute('data-fcpo-styles', '');
        fsty.appendChild(swrap);
        box.appendChild(fsty);
      }

      var fcap = el('div', 'fcpo__field');
      fcap.appendChild(el('span', 'fcpo__label',
        esc(STY.colorLabel || 'Color') + '<span class="fcpo__count" data-fcpo-capname></span>'));
      var cwrap = el('div', 'fcpo__photos');
      cwrap.setAttribute('data-fcpo-caps', '');
      fcap.appendChild(cwrap);
      box.appendChild(fcap);
    }

    if (SIZERUN) {
      var fr = el('div', 'fcpo__field');
      fr.setAttribute('data-fcpo-runfield', '');
      fr.appendChild(el('span', 'fcpo__label',
        'How many of each size? <em>*</em><span class="fcpo__count" data-fcpo-runtotal>0 pieces</span>'));
      var rwrap = el('div', 'fcpo__run');
      rwrap.setAttribute('data-fcpo-run', '');
      fr.appendChild(rwrap);
      fr.appendChild(el('p', 'fcpo__runtip', 'The quantity below adds up from these boxes. Same price for every size.'));
      box.appendChild(fr);
    }

    var f0 = el('div', 'fcpo__field');
    f0.appendChild(el('span', 'fcpo__label', 'What goes on it?'));
    var o0 = el('div', 'fcpo__opts');
    o0.innerHTML =
      chip('fcpo-mode', 'text', 'Text', 'We set it in the font you pick', state.mode !== 'logo') +
      chip('fcpo-mode', 'logo', 'My logo', 'Upload it here, or email it later', state.mode === 'logo');
    f0.appendChild(o0);
    box.appendChild(f0);

    var f1 = el('div', 'fcpo__field');
    f1.setAttribute('data-fcpo-textfield', '');
    f1.appendChild(el('span', 'fcpo__label',
      'Your text <em>*</em><span class="fcpo__count" data-fcpo-count>0 / 40</span>'));
    var inp = el('input', 'fcpo__input');
    inp.type = 'text';
    inp.maxLength = 40;
    inp.placeholder = 'e.g. Harbor Street Coffee';
    inp.setAttribute('data-fcpo-text', '');
    inp.value = state.text;
    f1.appendChild(inp);
    box.appendChild(f1);

    var fu = el('div', 'fcpo__field');
    fu.setAttribute('data-fcpo-filefield', '');
    fu.appendChild(el('span', 'fcpo__label', 'Your artwork <span class="fcpo__count" data-fcpo-filename></span>'));
    var fin = document.createElement('input');
    fin.type = 'file';
    fin.name = 'properties[Artwork file]';
    fin.accept = 'image/*,.pdf,.ai,.eps,.svg';
    fin.className = 'fcpo__file';
    fin.setAttribute('data-fcpo-file', '');
    fin.id = 'fcpo-file-input';
    fu.appendChild(fin);
    fu.appendChild(el('label', 'fcpo__drop', '<span class="fcpo__dropin"><strong>Choose a file</strong><small>PNG, JPG, PDF, AI, EPS or SVG · up to 20 MB</small></span>'));
    fu.lastChild.setAttribute('for', 'fcpo-file-input');
    fu.appendChild(el('p', 'fcpo__hint', 'Optional. Attach it now and it comes through with the order — or skip it and email it to us later.'));
    box.appendChild(fu);

    var f2 = el('div', 'fcpo__field');
    f2.setAttribute('data-fcpo-fontfield', '');
    f2.appendChild(el('span', 'fcpo__label', 'Font'));
    var fw = el('div', 'fcpo__fonts');
    var fh = '';
    for (var i = 0; i < FONTS.length; i++) fh += fontCard(FONTS[i].n, FONTS[i].c, state.font === FONTS[i].n);
    fh += fontCard(REC, 'fcpo-frec', state.font === REC, '&#9998;');
    fw.innerHTML = fh;
    f2.appendChild(fw);
    box.appendChild(f2);

    var fc = el('div', 'fcpo__field');
    fc.appendChild(el('span', 'fcpo__label', '<span data-fcpo-colorlabel>Thread color</span>' +
      '<span class="fcpo__count" data-fcpo-picked></span>'));
    var cw = el('div', 'fcpo__swatches');
    cw.setAttribute('data-fcpo-colors', '');
    fc.appendChild(cw);
    fc.appendChild(el('p', 'fcpo__hint', '<span data-fcpo-colorhint></span>'));
    box.appendChild(fc);

    if (places.length > 1) {
      var f3 = el('div', 'fcpo__field');
      f3.appendChild(el('span', 'fcpo__label', 'Where do you want it?'));
      var o3 = el('div', 'fcpo__opts');
      var h3 = '';
      for (var j = 0; j < places.length; j++) h3 += chip('fcpo-place', String(j), places[j].v, '', state.place === j);
      o3.innerHTML = h3;
      f3.appendChild(o3);
      box.appendChild(f3);
    }

    var f4 = el('div', 'fcpo__field');
    f4.appendChild(el('span', 'fcpo__label', 'How big is the logo?'));
    var o4 = el('div', 'fcpo__opts');
    o4.setAttribute('data-fcpo-sizes', '');
    f4.appendChild(o4);
    box.appendChild(f4);

    var f5 = el('div', 'fcpo__field');
    f5.appendChild(el('span', 'fcpo__label', 'Before we make it'));
    var pw = el('div', 'fcpo__proof');
    var ph = '';
    for (var q = 0; q < PROOFS.length; q++) ph += proofCard(PROOFS[q], state.proof === PROOFS[q].k);
    pw.innerHTML = ph;
    f5.appendChild(pw);
    box.appendChild(f5);

    var f6 = el('div', 'fcpo__field');
    f6.appendChild(el('span', 'fcpo__label', 'Where can we reach you? <em>*</em>'));
    var two = el('div', 'fcpo__two');
    two.innerHTML =
      '<div><label for="fcpo-phone">Mobile number (text OK)</label>' +
      '<input class="fcpo__input" type="tel" id="fcpo-phone" inputmode="tel" autocomplete="tel" ' +
      'maxlength="24" placeholder="(516) 555-0134" data-fcpo-phone></div>' +
      '<div><label for="fcpo-email">Email</label>' +
      '<input class="fcpo__input" type="email" id="fcpo-email" autocomplete="email" ' +
      'maxlength="80" placeholder="you@company.com" data-fcpo-email></div>';
    f6.appendChild(two);
    var pinp = two.querySelector('[data-fcpo-phone]');
    if (pinp) pinp.value = state.phone;
    var einp = two.querySelector('[data-fcpo-email]');
    if (einp) einp.value = state.email;
    f6.appendChild(el('p', 'fcpo__hint',
      'We text or email you about the proof and anything we need to check on this order. Not used for marketing.'));
    box.appendChild(f6);

    box.appendChild(el('p', 'fcpo__note',
      'The picture is a rough placement guide, not the finished artwork.'));
    box.appendChild(el('p', 'fcpo__err', 'Please type the text you want on it — or switch to “My logo” above.'));

    var pin = document.createElement('input');
    pin.type = 'file';
    pin.name = 'properties[Mockup]';
    pin.className = 'fcpo__file';
    pin.setAttribute('data-fcpo-proof', '');
    pin.disabled = true;
    box.appendChild(pin);

    [PROP_STYLE, PROP_COLOR, 'Sizes', 'Artwork', 'Text', 'Font', 'Color', 'Placement', 'Logo size',
     'Proof', 'Mobile', 'Email', 'Design link'].forEach(function (k) {
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = 'properties[' + k + ']';
      h.setAttribute('data-fcpo-prop', k);
      box.appendChild(h);
    });

    return box;
  }

  function renderStyles() {
    if (!STY || !root) return;
    var wrap = root.querySelector('[data-fcpo-styles]');
    if (!wrap) return;
    var h = '';
    for (var i = 0; i < STY.styles.length; i++) {
      h += chip('fcpo-style', String(i), STY.styles[i].n, '', state.styleIdx === i);
    }
    wrap.innerHTML = h;
  }

  function renderCaps() {
    if (!STY || !root) return;
    var wrap = root.querySelector('[data-fcpo-caps]');
    if (!wrap) return;
    var st = curStyle();
    if (!st) return;
    state.styleName = st.n;
    state.styleSku = st.sku || '';
    var list = st.colors || [];
    if (!list.length) { wrap.innerHTML = ''; return; }
    var keep = 0, i;
    for (i = 0; i < list.length; i++) if (list[i][0] === state.capColor) { keep = i; break; }
    state.capColor = list[keep][0];
    state.capImg = list[keep][1];
    state.capImgBack = list[keep][2] || '';
    var h = '';
    for (i = 0; i < list.length; i++) {
      var id = 'fcpo-cap-' + String(st.n + '-' + list[i][0]).replace(/[^a-zA-Z0-9]+/g, '');
      h += '<span class="fcpo__opt fcpo__opt--ph">' +
        '<input type="radio" name="fcpo-cap" id="' + id + '" value="' + esc(list[i][0]) +
        '" data-img="' + esc(list[i][1]) + '" data-img2="' + esc(list[i][2] || '') + '"' +
        (i === keep ? ' checked' : '') + '>' +
        '<label for="' + id + '" title="' + esc(list[i][0]) + '">' +
        '<img class="fcpo__ph" src="' + esc(list[i][1]) + '" alt="' + esc(list[i][0]) + '" loading="lazy">' +
        '</label></span>';
    }
    wrap.innerHTML = h;
  }

  function swapPhoto(url) {
    if (!url) return;
    var box = findMedia();
    if (!box) return;
    var img = box.querySelector('img:not(.fcpo-ov__img)');
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('crossorigin', 'anonymous');
    img.src = url;
    if (img.complete) { drawOverlay(); }
    else { img.addEventListener('load', drawOverlay, { once: true }); }
    setTimeout(drawOverlay, 300);
  }

  function renderSizes() {
    if (!root) return;
    var wrap = root.querySelector('[data-fcpo-sizes]');
    if (!wrap) return;
    var p = places[state.place];
    var h = '';
    for (var i = 0; i < 3; i++) h += chip('fcpo-size', String(i), sizeLabel(p, i), '', state.size === i);
    wrap.innerHTML = h;
  }

  function renderColors(force) {
    if (!root) return;
    var m = methodOf(variantTitle());
    if (!force && m === state.method) return;
    state.method = m;
    var pal = paletteFor(m);
    var wrap = root.querySelector('[data-fcpo-colors]');
    var lab = root.querySelector('[data-fcpo-colorlabel]');
    var hint = root.querySelector('[data-fcpo-colorhint]');
    if (!wrap) return;
    wrap.className = pal.chart ? 'fcpo__swatches fcpo__chart' : 'fcpo__swatches';
    if (lab) lab.textContent = pal.label;
    if (hint) hint.textContent = pal.hint;

    var keep = -1, i;
    for (i = 0; i < pal.list.length; i++) if (pal.list[i][0] === state.color) { keep = i; break; }
    if (keep < 0) keep = 0;
    state.color = pal.list[keep][0];
    state.colorCss = pal.list[keep][1];

    var h = '';
    for (i = 0; i < pal.list.length; i++) {
      h += swatch(pal.list[i][0], pal.list[i][1], !pal.chart, i === keep);
    }
    wrap.innerHTML = h;
  }

  function syncProps() {
    if (!root) return;
    var p = places[state.place];
    var pr = proofOf(state.proof);
    var vals = {};
    vals[PROP_STYLE] = STY ? (state.styleName + (state.styleSku ? ' (' + state.styleSku + ')' : '')) : '';
    vals[PROP_COLOR] = state.capColor;
    vals.Sizes = runLabel();
    vals.Artwork = state.mode === 'logo' ? (state.fileName ? 'My logo — file attached' : 'My logo — I will email the file') : 'Custom text';
    vals.Text = state.mode === 'logo' ? '' : state.text.trim();
    vals.Font = state.mode === 'logo' ? '' : state.font;
    vals.Color = state.color;
    vals.Placement = p.v;
    vals['Logo size'] = sizeLabel(p, state.size);
    vals.Proof = pr.pv;
    vals.Mobile = state.phone.trim();
    vals.Email = state.email.trim();
    vals['Design link'] = designLink();
    root.querySelectorAll('[data-fcpo-prop]').forEach(function (h) {
      var v = vals[h.getAttribute('data-fcpo-prop')];
      h.value = v || '';
      h.disabled = !v;
    });
  }

  function syncUI() {
    if (!root) return;
    var isLogo = state.mode === 'logo';
    var tf = root.querySelector('[data-fcpo-textfield]');
    var ff = root.querySelector('[data-fcpo-fontfield]');
    if (tf) tf.style.display = isLogo ? 'none' : '';
    if (ff) ff.style.display = isLogo ? 'none' : '';
    var c = root.querySelector('[data-fcpo-count]');
    if (c) c.textContent = state.text.length + ' / 40';
    var picked = root.querySelector('[data-fcpo-picked]');
    if (picked) picked.textContent = state.color;
    var capn = root.querySelector('[data-fcpo-capname]');
    if (capn) capn.textContent = state.capColor;
    var uf = root.querySelector('[data-fcpo-filefield]');
    var ui = root.querySelector('[data-fcpo-file]');
    if (uf) uf.style.display = isLogo ? '' : 'none';
    if (ui) ui.disabled = !isLogo;
    var un = root.querySelector('[data-fcpo-filename]');
    if (un) un.textContent = state.fileName;
    var dz = root.querySelector('.fcpo__drop');
    if (dz) dz.classList.toggle('has-file', !!state.fileName);
    var sample = state.text.trim() || 'Your Text';
    root.querySelectorAll('[data-fcpo-sample]').forEach(function (s) {
      if (s.classList.contains('fcpo-frec')) return;
      s.textContent = sample;
    });
    var okText = isLogo || state.text.trim();
    var okRun = !SIZERUN || runTotal() >= minQty();
    var okPhone = digits(state.phone).length >= 7;
    if (okText && okRun && okPhone) root.classList.remove('is-invalid');
    updateRunUI();
    syncQty();
    syncProps();
    drawOverlay();
  }

  function findMedia() {
    return document.querySelector('.product-media--image .img-ar')
        || document.querySelector('.product-media .img-ar')
        || document.querySelector('.media-gallery .img-ar');
  }
  function ensureOverlay() {
    mediaBox = findMedia();
    if (!mediaBox) return false;
    if (!overlay || !mediaBox.contains(overlay)) {
      overlay = el('div', 'fcpo-ov');
      mediaBox.appendChild(overlay);
      overlayTag = el('span', 'fcpo-ovtag', 'Placement preview');
      mediaBox.appendChild(overlayTag);
    }
    return true;
  }

  function shownRect() {
    var img = mediaBox && mediaBox.querySelector('img:not(.fcpo-ov__img)');
    if (!img) return null;
    var box = mediaBox.getBoundingClientRect();
    var nw = img.naturalWidth || box.width;
    var nh = img.naturalHeight || box.height;
    var scale = Math.min(box.width / nw, box.height / nh);
    var dw = nw * scale, dh = nh * scale;
    return { img: img, nw: nw, nh: nh, dw: dw, dh: dh,
             ox: (box.width - dw) / 2, oy: (box.height - dh) / 2 };
  }

  function drawOverlay() {
    if (!ensureOverlay()) return;
    var p = places[state.place];
    var r = shownRect();
    if (!r) return;

    var ratio = p.sizes[state.size] / p.sizes[1];
    var wPct = p.w * ratio;
    var target = r.dw * wPct / 100;
    var hPct = (p.h || 0) * ratio;
    var targetH = hPct > 0 ? r.dh * hPct / 100 : 0;

    overlay.style.left = (r.ox + r.dw * p.x / 100) + 'px';
    overlay.style.top = (r.oy + r.dh * p.y / 100) + 'px';
    overlay.style.width = target + 'px';

    var col = state.colorCss || 'rgb(28,26,23)';
    var light = lum(col) > 0.72;
    var shadow = light ? '0 0 2px rgba(0,0,0,.55)' : '0 1px 2px rgba(255,255,255,.4)';

    if (state.mode === 'logo') {
      overlay.style.display = '';
      if (overlayTag) overlayTag.style.display = '';
      if (state.fileUrl) {
        overlay.innerHTML = '<img class="fcpo-ov__img" alt="">';
        overlay.firstChild.src = state.fileUrl;
      } else {
        overlay.innerHTML = '<span class="fcpo-ov__logo">Your logo</span>';
        var lg = overlay.firstChild;
        lg.style.borderColor = col;
        lg.style.color = col;
        lg.style.textShadow = shadow;
        if (targetH > 0) { lg.style.aspectRatio = 'auto'; lg.style.height = targetH + 'px'; }
      }
      return;
    }

    var txt = state.text.trim();
    if (!txt) {
      overlay.style.display = 'none';
      if (overlayTag) overlayTag.style.display = 'none';
      return;
    }
    overlay.style.display = '';
    if (overlayTag) overlayTag.style.display = '';
    overlay.innerHTML = '<span class="fcpo-ov__t" data-fcpo-ovtext></span>';
    var t = overlay.firstChild;
    t.textContent = txt;
    t.className = 'fcpo-ov__t ' + fontClass(state.font === REC ? 'Clean Sans' : state.font);
    t.style.color = col;
    t.style.textShadow = shadow;
    t.style.transform = '';
    t.style.transformOrigin = 'center center';
    t.style.fontSize = '100px';
    var natural = t.scrollWidth || 1;
    t.style.fontSize = Math.max(5, Math.min(160, 100 * target / natural)) + 'px';

    if (targetH > 0) {
      var rh = t.getBoundingClientRect().height || 1;
      var sy = targetH / rh;
      if (sy < 0.6) sy = 0.6;
      if (sy > 6) sy = 6;
      t.style.transform = 'scaleY(' + sy + ')';
    }
  }

  function proofName() {
    var bits = [];
    if (state.styleName) bits.push(state.styleName);
    if (state.capColor) bits.push(state.capColor);
    var p = places[state.place];
    if (p && p.v) bits.push(p.v);
    if (state.mode === 'logo') bits.push('logo');
    else if (state.text.trim()) bits.push(state.text.trim());
    var s = bits.join(' ').replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    return 'mockup-' + (s || 'design').slice(0, 60) + '.jpg';
  }

  function drawArt(x, cw, ch, k, done) {
    var p = places[state.place];
    var ratio = p.sizes[state.size] / p.sizes[1];
    var cx = cw * p.x / 100, cy = ch * p.y / 100;
    var targetW = cw * (p.w * ratio) / 100;
    var hPct = (p.h || 0) * ratio;
    var targetH = hPct > 0 ? ch * hPct / 100 : 0;
    var col = state.colorCss || 'rgb(28,26,23)';

    if (state.mode === 'logo') {
      if (!state.fileUrl) {
        x.save();
        x.strokeStyle = col; x.lineWidth = Math.max(2, cw / 300);
        var bh = targetH > 0 ? targetH : targetW * 0.6;
        x.strokeRect(cx - targetW / 2, cy - bh / 2, targetW, bh);
        x.fillStyle = col;
        x.font = Math.round(targetW / 9) + 'px sans-serif';
        x.textAlign = 'center'; x.textBaseline = 'middle';
        x.fillText('YOUR LOGO', cx, cy);
        x.restore();
        done();
        return;
      }
      var lg = new Image();
      lg.onload = function () {
        var iw = lg.naturalWidth || 1, ih = lg.naturalHeight || 1;
        var w = targetW, h = w * ih / iw;
        if (targetH > 0 && h > targetH) { h = targetH; w = h * iw / ih; }
        x.drawImage(lg, cx - w / 2, cy - h / 2, w, h);
        done();
      };
      lg.onerror = function () { done(); };
      lg.src = state.fileUrl;
      return;
    }

    var txt = state.text.trim();
    if (!txt) { done(); return; }
    var t = overlay && overlay.querySelector('.fcpo-ov__t');
    if (!t) { done(); return; }
    var cs = window.getComputedStyle(t);
    var fs = parseFloat(cs.fontSize) * k;
    var sy = 1;
    var mm = String(t.style.transform).match(/scaleY[(]([0-9.]+)[)]/);
    if (mm) sy = parseFloat(mm[1]) || 1;

    x.save();
    x.fillStyle = col;
    x.textAlign = 'center';
    x.textBaseline = 'middle';
    try { if ('letterSpacing' in x) x.letterSpacing = (parseFloat(cs.letterSpacing) || 0) * k + 'px'; } catch (e) {}
    x.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + fs + 'px ' + cs.fontFamily;
    x.translate(cx, cy);
    x.scale(1, sy);
    x.fillText(txt, 0, 0);
    x.restore();
    done();
  }

  function makeProof(cb) {
    var done = false;
    var finish = function (f) { if (!done) { done = true; cb(f); } };
    setTimeout(function () { finish(null); }, 7000);
    try {
      var r = shownRect();
      if (!r) { finish(null); return; }
      var src = r.img.currentSrc || r.img.src;
      var base = new Image();
      base.crossOrigin = 'anonymous';
      base.onload = function () {
        try {
          var W = base.naturalWidth, H = base.naturalHeight;
          var lim = 1200;
          var s = Math.min(1, lim / Math.max(W, H));
          var cw = Math.max(1, Math.round(W * s)), ch = Math.max(1, Math.round(H * s));
          var c = document.createElement('canvas');
          c.width = cw; c.height = ch;
          var x = c.getContext('2d');
          x.fillStyle = '#ffffff';
          x.fillRect(0, 0, cw, ch);
          x.drawImage(base, 0, 0, cw, ch);
          drawArt(x, cw, ch, cw / r.dw, function () {
            try {
              c.toBlob(function (b) {
                if (!b) { finish(null); return; }
                try { finish(new File([b], proofName(), { type: 'image/jpeg' })); }
                catch (e2) { finish(null); }
              }, 'image/jpeg', 0.9);
            } catch (e3) { finish(null); }
          });
        } catch (e) { finish(null); }
      };
      base.onerror = function () { finish(null); };
      base.src = src;
    } catch (e) { finish(null); }
  }

  function attachProof(file) {
    var pin = root && root.querySelector('[data-fcpo-proof]');
    if (!pin) return;
    if (!file) { pin.disabled = true; return; }
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      pin.files = dt.files;
      pin.disabled = false;
    } catch (e) { pin.disabled = true; }
  }

  function getForm() {
    return document.querySelector('form.js-product-form')
        || document.querySelector('form[action*="/cart/add"]:not(.js-instalments-form)');
  }
  function mount() {
    var form = getForm();
    if (!form) return false;
    if (form.querySelector('[data-fcpo]')) { root = form.querySelector('[data-fcpo]'); return true; }
    root = buildFieldset();
    var anchor = form.querySelector('.quantity-submit-row') || form.querySelector('[name="add"]');
    if (anchor && anchor.parentNode === form) form.insertBefore(root, anchor);
    else form.insertBefore(root, form.firstChild);
    applyStylePlaces();
    renderStyles();
    renderCaps();
    renderRun();
    renderSizes();
    renderColors(true);
    syncUI();
    swapPhoto(viewImg());
    return true;
  }

  function pickFile(input) {
    var f = input.files && input.files[0];
    if (state.fileUrl) { try { URL.revokeObjectURL(state.fileUrl); } catch (err) {} }
    state.fileUrl = '';
    state.fileName = '';
    if (!f) { syncUI(); return; }
    if (f.size > 20 * 1024 * 1024) {
      input.value = '';
      alert('That file is larger than 20 MB. Please email it to info@hellofashioncity.com instead.');
      syncUI();
      return;
    }
    state.fileName = f.name;
    if (f.type.indexOf('image/') === 0 && f.type.indexOf('svg') < 0) {
      state.fileUrl = URL.createObjectURL(f);
    }
    syncUI();
    setTimeout(drawOverlay, 60);
  }

  document.addEventListener('input', function (e) {
    if (!root || !root.contains(e.target)) return;
    if (e.target.hasAttribute('data-fcpo-text')) { state.text = e.target.value; syncUI(); return; }
    if (e.target.hasAttribute('data-fcpo-phone')) { state.phone = e.target.value; syncUI(); return; }
    if (e.target.hasAttribute('data-fcpo-email')) { state.email = e.target.value; syncUI(); return; }
    if (e.target.hasAttribute('data-fcpo-run-size')) {
      var k = e.target.getAttribute('data-fcpo-run-size');
      var v = parseInt(e.target.value, 10);
      if (isNaN(v) || v < 0) v = 0;
      if (v > 9999) { v = 9999; e.target.value = '9999'; }
      state.run[k] = v;
      if (e.target.parentNode && e.target.parentNode.classList) {
        e.target.parentNode.classList.toggle('is-set', v > 0);
      }
      syncUI();
    }
  });

  document.addEventListener('change', function (e) {
    if (!root || !root.contains(e.target)) return;
    if (e.target.hasAttribute && e.target.hasAttribute('data-fcpo-file')) { pickFile(e.target); return; }
    var n = e.target.name;
    if (n === 'fcpo-style') {
      state.styleIdx = parseInt(e.target.value, 10) || 0;
      state.capColor = '';
      applyStylePlaces();
      renderCaps();
      renderSizes();
      swapPhoto(viewImg());
      syncUI();
      return;
    }
    if (n === 'fcpo-cap') {
      state.capColor = e.target.value;
      state.capImg = e.target.getAttribute('data-img');
      state.capImgBack = e.target.getAttribute('data-img2') || '';
      swapPhoto(viewImg());
      syncUI();
      return;
    }
    if (n === 'fcpo-mode') { state.mode = e.target.value; syncUI(); }
    else if (n === 'fcpo-font') { state.font = e.target.value; syncUI(); }
    else if (n === 'fcpo-proof') { state.proof = e.target.value; syncUI(); }
    else if (n === 'fcpo-color') { state.color = e.target.value; state.colorCss = e.target.getAttribute('data-css'); syncUI(); }
    else if (n === 'fcpo-place') {
      state.place = parseInt(e.target.value, 10) || 0;
      renderSizes();
      swapPhoto(viewImg());
      syncUI();
    }
    else if (n === 'fcpo-size') { state.size = parseInt(e.target.value, 10) || 0; syncUI(); }
  });

  function blocked() {
    if (state.mode === 'text' && !state.text.trim()) {
      return { msg: 'Please type the text you want on it — or switch to “My logo” above.',
               focus: '[data-fcpo-text]' };
    }
    if (SIZERUN && runTotal() < minQty()) {
      return { msg: 'Please enter how many of each size — minimum ' + minQty() + ' pieces in total.',
               focus: '[data-fcpo-run-size]' };
    }
    if (digits(state.phone).length < 7) {
      return { msg: 'Please add a mobile number we can text about this order.',
               focus: '[data-fcpo-phone]' };
    }
    var em = state.email.trim();
    if (em && (em.indexOf('@') < 1 || em.indexOf('.') < 0)) {
      return { msg: 'That email address does not look right — please check it.',
               focus: '[data-fcpo-email]' };
    }
    return null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form.js-product-form')) return;
    if (!root || !form.contains(root)) return;
    if (sending) return;
    var b = blocked();
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      showErr(b.msg);
      var i = root.querySelector(b.focus);
      if (i) i.focus();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[name="add"]') : null;
    if (!btn) return;
    var form = getForm();
    if (!form || !root || !form.contains(root)) return;
    if (sending) return;
    var b = blocked();
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      showErr(b.msg);
      var i = root.querySelector(b.focus);
      if (i) i.focus();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    sending = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    syncQty();
    syncProps();
    makeProof(function (file) {
      attachProof(file);
      form.setAttribute('enctype', 'multipart/form-data');
      try { form.submit(); }
      catch (err) { sending = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    });
  }, true);

  window.addEventListener('resize', drawOverlay);
  window.addEventListener('load', drawOverlay);

  function watchVariant() {
    var t = variantTitle();
    if (t !== lastVariant) {
      lastVariant = t;
      renderColors(false);
      syncUI();
    }
  }

  function start() {
    applyLink();
    if (!mount()) { setTimeout(start, 250); return; }
    lastVariant = variantTitle();
    drawOverlay();
    setInterval(watchVariant, 400);
    var host = document.querySelector('.product-form') || document.body;
    new MutationObserver(function () {
      var form = getForm();
      if (form && !form.querySelector('[data-fcpo]')) { root = null; mount(); }
      if (!mediaBox || !document.contains(mediaBox)) { overlay = null; drawOverlay(); }
      syncQty();
      var want = viewImg();
      if (want) {
        var mb = findMedia();
        var im = mb && mb.querySelector('img:not(.fcpo-ov__img)');
        if (im && im.src !== want) swapPhoto(want);
      }
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();